import React from 'react';

const Paypal = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={60} height={40} viewBox="0 0 60 40" fill="none" {...props}>
    <path fill="#F7F7F7" d="M0 5a5 5 0 0 1 5-5h50a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5Z" />
    <path
      fill="#2199D6"
      d="M40.319 12.54c0 .16 0 .321-.16.482-1.284 6.417-5.455 8.502-10.91 8.502h-2.727c-.641 0-1.283.482-1.283 1.123l-1.444 8.984-.32 2.567c0 .481.32.802.64.802h4.974c.642 0 1.123-.481 1.123-.962v-.321l.963-5.776v-.32c.16-.642.641-.963 1.123-.963h.802c4.813 0 8.502-1.925 9.465-7.54.481-2.407.16-4.332-.962-5.615-.321-.321-.803-.642-1.284-.963Z"
    />
    <path
      fill="#252C5E"
      d="M39.036 12.06c-.16 0-.32-.161-.641-.161-.16 0-.482-.16-.642-.16-.802-.161-1.604-.161-2.406-.161h-7.38c-.16 0-.32 0-.481.16-.321.16-.642.482-.642.802l-1.604 9.947v.32c.16-.64.641-1.122 1.283-1.122h2.727c5.455 0 9.626-2.246 10.91-8.503 0-.16 0-.32.16-.481l-.963-.481c-.16-.16-.32-.16-.32-.16Z"
    />
    <path
      fill="#263577"
      d="M26.844 12.54c0-.32.321-.641.642-.802.16 0 .321-.16.481-.16h7.38c.802 0 1.765 0 2.407.16.16 0 .48 0 .641.16.16 0 .321.161.642.161.16 0 .16 0 .32.16.322.16.642.321.963.482.321-2.407 0-4.01-1.283-5.455C37.593 5.642 35.027 5 31.817 5h-9.465c-.641 0-1.283.482-1.283 1.123l-3.85 24.706c0 .481.32.963.802.963h5.775l1.444-9.305 1.604-9.947Z"
    />
  </svg>
);

export default Paypal;
